import type { AdminStats, OutreachItem, ThankYouMessage } from "../interfaces/admin";
import { apiClient } from "../lib/apiClient";

export async function fetchAdminStats(range: number = 90): Promise<AdminStats> {
  const { data } = await apiClient.get<{ stats: AdminStats }>(
    `/admin/overview/stats?range=${range}`,
  );
  return data.stats;
}

export async function fetchAdminOutreach(): Promise<OutreachItem[]> {
  const { data } = await apiClient.get<{ outreach: OutreachItem[] }>("/admin/overview/outreach");
  return data.outreach;
}

export async function fetchAdminThankYou(params?: {
  search?: string;
  org?: string;
}): Promise<ThankYouMessage[]> {
  const { data } = await apiClient.get<{ messages: ThankYouMessage[] }>(
    "/admin/thankyou-messages",
    { params },
  );
  return data.messages;
}
